import { useUserStore } from './modules/userStore'
import { useAppStore } from './modules/appStore'
import { useCompanyStore } from './modules/companyStore'

export const appStore = useAppStore()
export const userStore = useUserStore()
export const companyStore = useCompanyStore()
